module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACcAAAAPCAYAAABnXNZuAAAAAXNSR0IArs4c6QAAAElJREFUSA1j/P///2qGwQnOMAId939wuo1hM9MgdRjYWaOOIzd2RkNuNOTIDQFy9Y2mudGQIzcEyNU3qNMcC9BXl8j1GY313QcAQJoK80wM38sAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/minus_icon_white_small.png
// module id = 45
// module chunks = 0